import React from 'react';
import { WebsiteDesignProps } from './types';
import { Sparkles, Aperture, Globe2 } from 'lucide-react';
import { Button } from "@/components/ui/button";

const HolographicFuture: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Prism Institute";

    return (
        <div className="bg-black min-h-screen font-sans text-white overflow-hidden relative">
            {/* Holographic Gradients */}
            <div className="absolute top-0 left-0 w-full h-full opacity-40 bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"></div>
            <div className="absolute top-[-20%] left-[-20%] w-[80vw] h-[80vw] rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 blur-[150px] opacity-30 animate-spin-slow mix-blend-screen"></div>
            <div className="absolute bottom-[-20%] right-[-20%] w-[60vw] h-[60vw] rounded-full bg-gradient-to-r from-blue-500 via-green-500 to-yellow-500 blur-[150px] opacity-30 animate-pulse mix-blend-screen"></div>

            <nav className="relative z-20 p-8 flex justify-between items-center backdrop-blur-sm bg-white/5 border-b border-white/10">
                <div className="text-2xl font-bold tracking-widest uppercase bg-clip-text text-transparent bg-gradient-to-r from-pink-300 via-purple-300 to-cyan-300 drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">
                    {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button variant="outline" className="border-white/20 text-white hover:bg-white/10 hover:border-white/50 backdrop-blur rounded-full px-6 transition-all">
                        Login
                    </Button>
                    <Button className="bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full px-6 backdrop-blur shadow-[0_0_15px_rgba(255,255,255,0.2)] transition-all">
                        Apply
                    </Button>
                </div>
            </nav>

            <main className="relative z-10 container mx-auto px-8 py-20 flex flex-col items-center text-center">
                 <div className="mb-4 inline-flex items-center gap-2 px-4 py-1 rounded-full border border-white/10 bg-white/5 backdrop-blur text-xs font-bold uppercase tracking-widest text-cyan-200">
                     <Sparkles size={14} /> The Next Dimension
                 </div>
                 
                 <h1 className="text-7xl md:text-9xl font-black mb-8 leading-none tracking-tighter mix-blend-overlay opacity-90">
                     Future <br/> Proof.
                 </h1>
                 
                 <div className="relative w-full max-w-4xl p-1 rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 mb-12 shadow-[0_0_40px_rgba(168,85,247,0.4)]">
                     <div className="bg-black/90 rounded-xl p-8 md:p-12 backdrop-blur-xl">
                         <p className="text-xl md:text-2xl text-gray-200 font-light leading-relaxed">
                             "We don't just teach the future. <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400 font-bold">We invent it.</span>"
                         </p>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-5xl">
                     {[
                         { icon: Aperture, title: "Visionary", desc: "Seeing beyond the horizon." },
                         { icon: Globe2, title: "Global", desc: "Connected to every corner." },
                         { icon: Sparkles, title: "Creative", desc: "Imagination without limits." },
                     ].map((item, i) => (
                         <div key={i} className="group p-8 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/30 transition-all backdrop-blur hover:-translate-y-2 cursor-pointer">
                             <item.icon className="w-12 h-12 mb-4 mx-auto text-gray-400 group-hover:text-white transition-colors" />
                             <h3 className="text-2xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-b from-white to-gray-400">{item.title}</h3>
                             <p className="text-gray-400 text-sm">{item.desc}</p>
                         </div>
                     ))}
                 </div>
            </main>
        </div>
    );
};

export default HolographicFuture;
